import { Box } from '@mui/material';
import { LabeledValue, LabelIdValue } from '~/components/Fields/LabeledValue';
import { DoseMatrix } from '~/domain/patient/doseMatrix';
import useDose from '~/hooks/patient/dose/useDose';
import DoseTargets from './DoseTargets';

export default function DoseExportDetails({ dose }: { dose: DoseMatrix }) {
    const { dose: doseState } = useDose(dose);
    return (
        <Box py={1} display="grid" gap={1}>
            <Box display="grid" gridTemplateColumns="1fr 1fr 1fr">
                <LabeledValue label="Name" value={dose.plan?.label} />
                <LabeledValue
                    label="Summation type"
                    value={dose.doseSummationType}
                />
                <LabelIdValue label="Series Instance UID" id={dose.dicomUid} />
            </Box>
            <Box display="grid" gridTemplateColumns="1fr 1fr 1fr">
                <LabeledValue label="Dose type" value={dose.doseType} />
                <LabeledValue
                    label="Dose max"
                    value={dose.doseMaxGy.toFixed(1) + dose.doseUnits}
                />
                <LabeledValue
                    label="Prediction Model"
                    value={dose?.generationModel?.label}
                />
            </Box>
            {doseState?.targets && (
                <LabeledValue
                    label="Targets"
                    value={
                        <DoseTargets
                            units={dose.doseUnits}
                            targets={doseState.targets.filter(
                                (t) => t.isTarget
                            )}
                        />
                    }
                />
            )}
        </Box>
    );
}
